"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/** Stylesheets */
var icons = require("../../../styles/att-icon-login.scss");
var styles = require("./Logo.scss");
var Logo = /** @class */ (function (_super) {
    __extends(Logo, _super);
    function Logo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Logo.prototype.render = function () {
        return (React.createElement("div", { className: [styles.logoWrapper].join(' ') },
            React.createElement("div", { "aria-label": this.props.options.accessibilityText, role: "img", "data-test-id": this.props.testId },
                React.createElement("i", { className: [icons.attIconLogin, this.props.options.iconClassName].join(' ') }))));
    };
    return Logo;
}(React.Component));
exports.default = Logo;
//# sourceMappingURL=Logo.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/Logo/Logo.js
// module id = 579
// module chunks = 8